import { useCallback, useState } from 'react'

import { ErrorItem } from '@marketplace-web/shared/api-client'
import { updateVatNumber } from 'data/api/update-vat-number'
import { BusinessAccountVatDto } from 'types/dtos/business-account'
import { HttpStatus, ResponseCode } from 'data/api/response-codes'

export type onSubmitVatNumberParams = {
  submitVatData: BusinessAccountVatDto
  onSuccess?: () => void
}

const useSubmitVatNumber = (): {
  showGeneralError: boolean
  onSubmitVatNumber: ({ submitVatData, onSuccess }: onSubmitVatNumberParams) => Promise<void>
  loading: boolean
  apiErrors: Array<ErrorItem> | null
} => {
  const [showGeneralError, setShowGeneralError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [apiErrors, setApiErrors] = useState<Array<ErrorItem> | null>(null)

  const onSubmitVatNumber = useCallback(
    async ({ submitVatData, onSuccess }: onSubmitVatNumberParams) => {
      try {
        setApiErrors(null)
        setShowGeneralError(false)
        setLoading(true)

        const response = await updateVatNumber(submitVatData)

        if (!response) {
          setShowGeneralError(true)
        }

        if ('errors' in response) {
          setApiErrors(response.errors)

          if (
            response.code === ResponseCode.ServerError ||
            response.status === HttpStatus.InternalError ||
            response.status === HttpStatus.TooManyRequests ||
            response.status === HttpStatus.UnprocessableEntity
          ) {
            setShowGeneralError(true)
          }
        } else {
          onSuccess?.()
        }
      } catch (error) {
        setApiErrors(error)
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  return {
    loading,
    apiErrors,
    showGeneralError,
    onSubmitVatNumber,
  }
}

export default useSubmitVatNumber
